import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// import { CaseStudyData } from "../../common";
import { Container } from "reactstrap";
// core components
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import ProjectBanner from "../../components/Project/ProjectBanner";
import CustomerReviews from "../../components/CustomerReviews/CustomerReviews";
import OurLatestBlogs from "../../components/OurLatestBlogs/OurLatestBlogs";
import ContactUsComponent from "../../components/ContactUsComponent/ContactUsComponent";
import FrequentlyAskedQuestions from "../../components/FrequentlyAskedQuestions/FrequentlyAskedQuestions";
import CaseStudyApplications from "../../components/CaseStudy/CaseStudyApplications";
import TechIndustryQuality from "../../components/TechIndustryQuality/TechIndustryQuality";
import OptimizedPoc from "../../components/CaseStudy/OptimizedPoc";
// import { getIPGeoLocation } from "../../common/GeneralUtils";
import axios from "axios";
import Toasts from "../../components/Toasts/Toasts";
// import { useLocation } from "react-router-dom";

// import Loadable from "../../components/Loadable"

// const Header = Loadable(
//     lazy(() => import('../../components/header/header'))
// )
// const Footer = Loadable(
//     lazy(() => import('../../components/footer/footer'))
// )
// const ProjectBanner = Loadable(
//     lazy(() => import('../../components/Project/ProjectBanner'))
// )
// const CustomerReviews = Loadable(
//     lazy(() => import('../../components/CustomerReviews/CustomerReviews'))
// )
// const OurLatestBlogs = Loadable(
//     lazy(() => import('../../components/OurLatestBlogs/OurLatestBlogs'))
// )
// const ContactUsComponent = Loadable(
//     lazy(() => import('../../components/ContactUsComponent/ContactUsComponent'))
// )
// const FrequentlyAskedQuestions = Loadable(
//     lazy(() => import('../../components/FrequentlyAskedQuestions/FrequentlyAskedQuestions'))
// )
// const CaseStudyApplications = Loadable(
//     lazy(() => import('../../components/CaseStudy/CaseStudyApplications'))
// )
// const TechIndustryQuality = Loadable(
//     lazy(() => import('../../components/TechIndustryQuality/TechIndustryQuality'))
// )
// const OptimizedPoc = Loadable(
//     lazy(() => import('../../components/CaseStudy/OptimizedPoc'))
// )

const CaseStudyScreen = () => {
    // const location = useLocation();
    const [toasts, setToasts] = useState(null)
    const [techIndustryQualityData, setTechIndustryQualityData] = useState({});
    const [CaseStudyData, setData] = useState({});
    const [geoLocationData, setGeoLocationData] = useState(null);

    const getAllCaseStudyData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/caseStudyData.json');
            setData(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }
    const getAllCustomerReviewsData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/techIndustryQualityData.json');
            setTechIndustryQualityData(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }

    useEffect(() => {
        // getIPGeoLocation(location.pathname)
        getAllCaseStudyData()
        getAllCustomerReviewsData()
    }, [])


    return (
        <div id="main-wrapper">
            <Header geoLocation={setGeoLocationData} />
            <div className="page-wrapper">
                <div className="container-fluid">
                    <div className="project-page">
                        <ProjectBanner bannerImg={CaseStudyData?.bannerImg} data={CaseStudyData?.headerData} />
                        <Container className='acss-18azjcp' >
                            <div className='custom-pending-top'>
                                <CaseStudyApplications data={CaseStudyData?.models} />
                            </div>
                        </Container>
                        <TechIndustryQuality techIndustryQualityData={techIndustryQualityData} />
                        <OptimizedPoc />
                        <CustomerReviews />
                        <OurLatestBlogs />
                        <div className="home-contact-page">
                            <ContactUsComponent setToasts={setToasts} GeoIpData={geoLocationData} />
                        </div>
                        <FrequentlyAskedQuestions faqData={CaseStudyData?.FrequentlyAskedQuestionsData} />
                    </div>
                </div>
            </div>
            <Footer />
            {toasts && <Toasts toastsList={toasts} />}
        </div>
    );
}

CaseStudyScreen.propTypes = {
    classes: PropTypes.object
};

export default CaseStudyScreen;
